module.exports = __webpack_public_path__ + "img/Inflation Infographic.e828efae.png";